import { render, staticRenderFns } from "./supplierstatistics.vue?vue&type=template&id=549a7b37&"
import script from "./supplierstatistics.vue?vue&type=script&lang=js&"
export * from "./supplierstatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports